
import { RouteObject } from'react-router-dom';
import { ProfileLanding } from './components/Landing';

export interface profileRoute extends Omit<RouteObject,'children'> {
 auth?: boolean;
 children?: profileRoute[];
}

export const profileRoutes:profileRoute[] = [
 {
 path:'/profile',
 element: <ProfileLanding />,
 },
];